import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=78ea1f4a&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=78ea1f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ea1f4a",
  null
  
)

/* custom blocks */
import block0 from "./Company.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports